import React, { useState, useRef, useEffect } from 'react';
import Icon from '../AppIcon';


const SearchBar = ({ onSearch, placeholder = 'Search prompts...', showResults = false }) => {
  const [query, setQuery] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [results, setResults] = useState([]);
  const searchRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef?.current && !searchRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event?.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  useEffect(() => {
    if (query?.trim() && showResults) {
      const mockResults = [
        {
          id: 1,
          title: 'Marketing Campaign Prompt',
          category: 'Marketing',
          date: '2026-01-05'
        },
        {
          id: 2,
          title: 'Code Review Assistant',
          category: 'Development',
          date: '2026-01-04'
        },
        {
          id: 3,
          title: 'Content Creation Guide',
          category: 'Content',
          date: '2026-01-03'
        }
      ]?.filter(item => 
        item?.title?.toLowerCase()?.includes(query?.toLowerCase()) ||
        item?.category?.toLowerCase()?.includes(query?.toLowerCase())
      );

      setResults(mockResults);
      setIsOpen(mockResults?.length > 0);
    } else {
      setResults([]);
      setIsOpen(false);
    }
  }, [query, showResults]);

  const handleSearch = (e) => {
    const value = e?.target?.value;
    setQuery(value);
    if (onSearch) {
      onSearch(value);
    }
  };

  const handleResultClick = (result) => {
    console.log('Selected result:', result);
    setIsOpen(false);
    setQuery('');
  };

  const handleKeyDown = (e) => {
    if (e?.key === 'Enter' && onSearch) {
      onSearch(query);
      setIsOpen(false);
    }
  };

  return (
    <div className="search-container" ref={searchRef}>
      <div className="search-input-wrapper">
        <div className="search-icon">
          <Icon name="Search" size={20} />
        </div>
        <input
          type="text"
          className="search-input"
          placeholder={placeholder}
          value={query}
          onChange={handleSearch}
          onKeyDown={handleKeyDown}
          onFocus={() => query?.trim() && showResults && setIsOpen(true)}
        />
      </div>
      {isOpen && results?.length > 0 && (
        <div className="search-results custom-scrollbar">
          {results?.map((result) => (
            <div
              key={result?.id}
              className="search-result-item"
              onClick={() => handleResultClick(result)}
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="font-semibold text-foreground mb-1">
                    {result?.title}
                  </div>
                  <div className="text-sm text-muted-foreground">
                    {result?.category} • {result?.date}
                  </div>
                </div>
                <Icon name="ChevronRight" size={20} className="text-muted-foreground" />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchBar;